import axios from 'axios';
import { SITE_URL } from '@pocketsurge/shared/constants';

export const API_BASE = import.meta.env.VITE_API_URL ?? 'https://pocketsurge-api.pocketsurge-com.workers.dev/api';

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) {
      const path = window.location.pathname;
      if (!path.startsWith('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export function getImageUrl(path: string): string {
  if (/^https?:\/\//.test(path)) return path;
  return `${import.meta.env.VITE_CDN_URL ?? `https://${SITE_URL.replace('https://', '')}`}/${path}`;
}

export const CDN_BASE = import.meta.env.VITE_CDN_URL ?? '';
